<template>
  <div class="recharge">
    <Header :userInfo="userInfo"/>
    <Client @chooseClient="chooseClient" :balance="balance"/>
    <Picking :cards="cards" @chooseMoney="chooseMoney" @showNotice="showNotice"/>
    <Notice :close-btn="true" :width="530" :height="610" ref="notice">
      <div class="notice-main">
        <h1 class="title">充值确认</h1>
        <p class="desc">请核对您的账号及金额</p>
        <table class="table">
          <tr>
            <td class="title">账号</td>
            <td class="desc">{{userInfo.userId}}</td>
          </tr>
          <tr>
            <td class="title">设备</td>
            <td class="desc">{{clientType | client}}</td>
          </tr>
          <tr>
            <td class="title">金额</td>
            <td class="desc">{{money}}知米</td>
          </tr>
        </table>
        <UIButton class="button" :width="330" :height="70" @click="pay">充值</UIButton>
      </div>
    </Notice>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Header from './Header'
import Client from './Client'
import Picking from './Picking'
import Notice from '../../components/Notice'
import UIButton from '../../components/UI/Button'
import api from '@edu-fe/api'
import Pay from '@edu-fe/pay'
import login from '@/utils/login'

export default {
  data () {
    return {
      cards: [],
      money: 6,
      clientType: 2,
      balance: 0,
      paying: false
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  filters: {
    client (type) {
      return type === 1 ? '安卓设备' : '苹果设备'
    }
  },
  methods: {
    ...mapActions(['getUserInfo']),
    async checkLogin () {
      await login.login()
    },
    chooseMoney (card) {
      this.money = card.price
      this.courseId = card.id
    },
    chooseClient (type) {
      this.clientType = type
      this.getInfo()
    },
    showNotice () {
      this.$refs.notice.show()
    },
    async getInfo () {
      const { data } = await api.recharge.getInfo(this.clientType)()
      this.cards = data.list
      this.courseId = data.list[0].id
      this.balance = data.balance
    },
    pay () {
      new Pay({
        courseId: this.courseId,
        type: 12,
        from: this.$route.query.from,
        price: this.money,
        // payment: true,
        isSend: 1, // 将payment改为isSend, 用于阻止支付模块查看课程是否已购买, 后台无影响, 畅学卡买了就是自己的
        payWay: '10', // 资源券, 10:微信
        usedReward: 0,
        loginCallback: wpsSid => {
          this.paying = false

        },
        gotoResult: orderId => {
          this.$toast.show({ message: '支付成功' })
          this.getInfo ()
          this.$refs.notice.close()
        },
        gotoPayment: () => {
          this.paying = false
          this.getInfo ()
        },
        failCallback: () => {
          this.paying = false
          this.$toast.show({ message: '支付失败，请稍后重试' })
        },
        cancelCallback: () => {
          this.paying = false
        }
      })

    }
  },
  created () {
    this.checkLogin()
    this.getUserInfo()
    this.getInfo()
  },
  beforeDestroy () {
  },
  components: {
    Header,
    Client,
    Picking,
    Notice,
    UIButton
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.recharge {
  background: #F7F7F7;
  .notice-main {
    padding: rem(60) rem(40);
    .title {
      font: {
        size: rem(36);
        weight: bold;
      };
      color: #333;
      line-height: rem(50);
      margin-bottom: rem(10);
    }
    .desc {
      line-height: rem(40);
      color: #999999;
      font-size: rem(28);
      margin-bottom: rem(40);
    }
    .button {
      margin: auto;
      font: {
        size: rem(32);
        weight: bold;
      };
    }
    .table {
      margin-bottom: rem(40);
      td {
        height: rem(75);
        border: rem(2) solid #CCCCCC;
      }
      .title {
        color: #666;
        width: rem(143);
        font: {
          size: rem(26);
        };
      }
      .desc {
        width: rem(307);
        font: {
          size: rem(32);
          weight: bold;
        };
        color: #333;
      }
    }
  }
}
</style>
